<h3>
  Following example shows a base page layout without multiple pages. If you have different pages (different header, ...) with routing see
  next example.
</h3>
<div>
  <h3>Design Guidelines</h3>
  <p>All pages in an application should follow a common layout structure to ensure a consistent user experience across applications.</p>
  <p>The Base Pagelayout includes the following components:</p>
  <ul>
    <li>Main Navigation</li>
    <li>Pagetitle</li>
    <li>Content Area</li>
  </ul>
  <p>Further components may complete the pagelayout as needed:</p>
  <ul>
    <li>Back Button</li>
    <li>Command bar</li>
    <li>Content-Panel</li>
  </ul>
  <h4>Command Bar</h4>
  <ul>
    <li>The Command Bar comprises the most common users tasks.</li>
    <li>The most important ones are shown, additional ones are accessible in an overflow-menu.</li>
    <li>
      Other commands, either less common ones or where the proximity to an ui element is crucial, are provided within the content area.
    </li>
  </ul>
</div>

<h3>Demo</h3>
<mad-primary-button routerLink="/full-page-layouts/base-page-layout">Open Base Pagelayout Demo</mad-primary-button><br />
<app-code-snippet [code]="basePageLayout"></app-code-snippet>
